export default __webpack_public_path__ + "static/media/12.754a2176.jpeg";